"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSettings = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var get_1 = (0, tslib_1.__importDefault)(require("lodash/get"));
var SettingsContext_1 = require("./SettingsContext");
var useSettings = function () {
    var settingsContext = (0, react_1.useContext)(SettingsContext_1.SettingsContext);
    if (settingsContext === undefined) {
        throw new Error('useSettings hook must be used within a SettingsProvider component');
    }
    var settings = settingsContext.settings, loading = settingsContext.loading, setNewSettings = settingsContext.setNewSettings;
    var dollarsDecimal = (0, get_1.default)(settings, 'DataParams.dollarsDecimal');
    var dateFormat = (0, get_1.default)(settings, 'DataParams.dateFormat');
    var universalTime = (0, get_1.default)(settings, 'DataParams.universalTime');
    return {
        dollarsDecimal: dollarsDecimal,
        dateFormat: dateFormat,
        universalTime: universalTime,
        loading: loading,
        setNewSettings: setNewSettings,
    };
};
exports.useSettings = useSettings;
